module.exports = __webpack_public_path__ + "assets/cd9008167701de76a484bd0506248b12.json";